
const state = {
  goodsList: [],
  signList: []
}

const mutations = {
  SET_GOODS: (state, list) => {
    state.goodsList = list
  },
  CLEAR_GOODS: (state) => {
    state.goodsList = []
  },
  SET_SIGN: (state, obj) => {
    state.signList = [...state.signList, obj]
  },
  CLEAR_SIGN: (state) => {
    state.signList = []
  }

}

const actions = {
  //   // 获取基本用户信息
  //   getInfo({ commit, state }) {
  //     return new Promise((resolve, reject) => {
  //       getInfo({ personalId: state.personalId })
  //         .then((res) => {
  //           const data = res.data
  //           if (!data) {
  //             reject(new Error('获取基本信息失败，请重新登录'))
  //           }
  //           commit('SET_USER_INFO', data)
  //           resolve(data)
  //         })
  //         .catch((error) => {
  //           reject(error)
  //         })
  //     })
  //   },

  //   // 重置token
  //   resetToken({ commit }) {
  //     return new Promise((resolve) => {
  //       commit('SET_TOKEN', '')
  //       removeToken()
  //       resolve()
  //     })
  //   },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
